import { useEffect, useState, useRef, useCallback, memo } from "react";
import { useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "../styles/dustbin.css";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../../components/Wishlist/WishlistSlice";
import { addToCart } from "../../Checkout/Cart/redux/cartSlice";
import { useCartWishlist } from "../../../app/CartWishlistContext";
import {
  formatDiscount,
  formatPrice,
} from "../../../utils/price.utils";
import { limitChars } from "../../../utils/text.utils";
import { getProductPdpUrl } from "../../../utils/url.utils";
import { GetHomeProductBySlug } from "../services/productListng.service";
import { toast } from "react-hot-toast";

function CleanLivingStart({ onQuickView }) {
  const [products, setProducts] = useState([]);
  // Professional loaders
  const [cartLoading, setCartLoading] = useState({});
  const [wishlistLoading, setWishlistLoading] = useState({});
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isLoggedIn = !!localStorage.getItem("token");

  const { getCartWishlistCount } = useCartWishlist();

  // Fetch products
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await GetHomeProductBySlug(
  //         "CLEAN_LIVING"
  //       );

  //       setProducts(data || []);
  //     } catch (error) {
  //       console.error(error);
  //       toast.error("Failed to fetch products");
  //     }
  //   };

  //   fetchData();
  // }, []);

 // FETCH PRODUCTS
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =
          await GetHomeProductBySlug(
            "CLEAN_LIVING"
          );

        console.log(
          "API RESPONSE:",
          response
        );

        // IMPORTANT FIX
        let productArray = [];

        if (Array.isArray(response)) {
          productArray = response;
        } else if (
          Array.isArray(response?.data)
        ) {
          productArray = response.data;
        } else if (
          Array.isArray(
            response?.products
          )
        ) {
          productArray =
            response.products;
        }

        setProducts(productArray);
      } catch (error) {
        console.error(error);

        setProducts([]);

        toast.error(
          "Failed to fetch products"
        );
      }
    };

    fetchData();
  }, []);

  // Product updater
  const updateProduct = useCallback(
    (productId, updates) => {
      setProducts((prev) =>
        prev.map((p) =>
          p.id === productId
            ? {
                ...p,
                ...updates,
              }
            : p
        )
      );
    },
    []
  );

  // Wishlist
  const toggleWishlist = async (e, product) => {
    e.stopPropagation();

    if (!isLoggedIn) {
      navigate("/login", {
        state: {
          from: location.pathname,
        },
      });

      return;
    }

    try {
      setWishlistLoading((prev) => ({
        ...prev,
        [product.id]: true,
      }));

      if (product.is_wishlisted) {
        const wishlistId =
          product.wishlist?.[0]?.wishlist_id;

        if (wishlistId) {
          await dispatch(
            removeFromWishlist(wishlistId)
          ).unwrap();

          updateProduct(product.id, {
            is_wishlisted: false,
            wishlist: [],
          });
        }
      } else {
        const response = await dispatch(
          addToWishlist({
            product_id: product.id,
          })
        ).unwrap();

        const wishlist = Array.isArray(response)
          ? response.find(
              (w) => w.product_id === product.id
            )
          : response;

        updateProduct(product.id, {
          is_wishlisted: true,
          wishlist: wishlist
            ? [{ wishlist_id: wishlist.id }]
            : [],
        });
      }

      getCartWishlistCount();
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setWishlistLoading((prev) => ({
        ...prev,
        [product.id]: false,
      }));
    }
  };

  // Add to cart
  const handleAddToCart = async (e, product) => {
    e.stopPropagation();

    if (!isLoggedIn) {
      navigate("/login", {
        state: {
          from: location.pathname,
        },
      });

      return;
    }

    try {
      setCartLoading((prev) => ({
        ...prev,
        [product.id]: true,
      }));

      const quantity = 1;

      const res = await dispatch(
        addToCart({
          product_id: product.id,
          quantity,
        })
      ).unwrap();

      toast.success(
        res?.data?.message || "Added to cart"
      );

      updateProduct(product.id, {
        addedToCartQuantity:
          (product.addedToCartQuantity || 0) +
          quantity,
      });

      getCartWishlistCount();
    } catch (error) {
      console.error(error);

      toast.error(
        error?.message || "Failed to add to cart"
      );
    } finally {
      setCartLoading((prev) => ({
        ...prev,
        [product.id]: false,
      }));
    }
  };

  // carater Limit 

  const [charLimit, setCharLimit] = useState(20);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCharLimit(15); // mobile
      } else {
        setCharLimit(28); // desktop
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Agar API no data section hide
  
// if (!products || products.length === 0) {
//     return null;
//   }

 // FIXED
  if (
    !Array.isArray(products) ||
    products.length === 0
  ) {
    return null;
  }

  return (
    <section className="dustbin-section">
      <div className="box-flex">
        <h2>SMART LIVING</h2>
      </div>

      <div
        className="container container-padding"
        style={{ maxWidth: "1500px" }}
      >
        <div className="product-swiper-wrapper">
          <button
            ref={prevRef}
            className="custom-prev"
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          <button
            ref={nextRef}
            className="custom-next"
          >
            <i className="bi bi-chevron-right"></i>
          </button>

          <Swiper
            modules={[Navigation]}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl =
                prevRef.current;

              swiper.params.navigation.nextEl =
                nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            spaceBetween={20}
            slidesPerView={5}
            loop
            speed={200}
            grabCursor
            breakpoints={{
              320: { slidesPerView: 2.2 },
              480: { slidesPerView: 2.2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 5.5 },
            }}
          >
            {Array.isArray(products) &&
                 products.map((item) => {
              const mainImage =
                item.media_list?.main?.file || "";

              const hoverImage =
                item.media_list?.hover?.file ||
                mainImage;

              const isCartLoading =
                cartLoading[item.id];

              const isWishlistLoading =
                wishlistLoading[item.id];

              return (
                <SwiperSlide key={item.id}>
                  <div className="product-card">
                    <div
                      className="image-box"
                      onClick={() =>
                        window.open(
                          getProductPdpUrl(
                            item.action_url,
                            item.sku
                          ),
                          "_blank"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={mainImage}
                        alt={item.name}
                        className="main-img"
                        loading="lazy"
                      />

                      <img
                        src={hoverImage}
                        alt={item.name}
                        className="hover-img"
                        loading="lazy"
                      />

                      <div className="icons-pr">
                        {/* Wishlist */}
                         <div className="tooltip-wrap">
                        <button
                          onClick={(e) =>
                            toggleWishlist(e, item)
                          }
                          className="icon-action-btn"
                          disabled={isWishlistLoading}
                        >
                          {isWishlistLoading ? (
                            <span className="icon-skeleton-loader">
                              <span className="icon-shimmer"></span>
                            </span>
                          ) : (
                            <i
                              className={
                                item.is_wishlisted
                                  ? "bi bi-heart-fill active"
                                  : "bi bi-heart"
                              }
                            />
                          )}
                        </button>
                         <span className="left-tooltip">
                            Add to wishlist
                          </span>
                        </div>

                        {/* Cart */}
                        <div className="tooltip-wrap">
                        <button
                          onClick={(e) =>
                            handleAddToCart(e, item)
                          }
                          className="icon-action-btn"
                          disabled={isCartLoading}
                        >
                          {isCartLoading ? (
                            <span className="icon-skeleton-loader">
                              <span className="icon-shimmer"></span>
                            </span>
                          ) : (
                            <i className="bi bi-bag"></i>
                          )}
                        </button>
                          <span className="left-tooltip">
                            Add to cart
                          </span>
                        </div>

                        {/* Quick View */}
                    <div className="tooltip-wrap">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();

                            onQuickView &&
                              onQuickView(item);
                          }}
                          className="icon-action-btn Quickviewicon-disable"
                          >
                          <i className="bi bi-eye"></i>
                        </button>
                          <span className="left-tooltip">
                            Add Quick View
                          </span>
                     </div>
                      </div>
                    </div>

                    <div className="details">
                      <h4 className="title-limit">
                        <Link
                          to={getProductPdpUrl(
                            item.action_url,
                            item.sku
                          )}
                          target="_blank"
                        >
                          {limitChars(item.name, charLimit)}
                        </Link>
                      </h4>

                      <div className="price">
                        <span className="new">
                          {formatPrice(
                            item.selling_price
                          )}
                        </span>

                        {item.discount_percent >
                          0 && (
                          <>
                            <span className="old">
                              {formatPrice(item.mrp)}
                            </span>

                            <span className="discount">
                              {formatDiscount(
                                item.discount_percent
                              )}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      <div className="container">
        <Link
          to="/dustbins" target="_blank"
          className="btn view-all-section"
         >
          VIEW ALL
        </Link>
      </div>
    </section>
  );
}
export default memo(CleanLivingStart);